export type Game = {
  id: number;
  slug: string;
  title: string;
  description: string;
  about: string;
  image: string;
  featuredImage: string;
  heroVideo?: string;
  trailerUrl?: string;
  media: string[];
  storeLink: string;
  badge: string;
  platform: 'steam' | 'itch';
  ctaLabel: string;
  hidden?: boolean;
};

export const games: Game[] = [
  {
    id: 1,
    slug: 'out-of-sync',
    title: 'Out Of Sync',
    description:
      'Keil, a junior employee at Vanta Inc., searches for his missing friend Marcus. A note in Marcus\'s handwriting leads him into a parallel world — and an unforgettable reality at the final door.',
    about:
      'Out Of Sync is an atmospheric exploration game where you step into different dimensions. Wander through six unique and distinct worlds, each featuring its own extraordinary visual style, to solve environmental puzzles as you navigate from one door to the next.',
    image: '/featured/Banners/header.jpg',
    featuredImage: '/featured/Banners/header.jpg',
    heroVideo: '/featured/videos/Out Of Sync Trailer V1.mp4',
    trailerUrl: 'https://youtu.be/FcSteJaY2c8?si=p5Fb5tWwySTIYCE9',
    media: [
      '/featured/media/OutOfSync-Win64-Shipping_DOYM4ss184.jpg',
      '/featured/media/OutOfSync-Win64-Shipping_5py4KrUuJ0.jpg',
      '/featured/media/FlashPoint-Win64-Shipping_8dOk4qERyP.jpg',
      '/featured/media/FlashPoint-Win64-Shipping_I8iy6OEQa3.jpg',
      '/featured/media/FlashPoint-Win64-Shipping_PC40JqjtD3.jpg',
      '/featured/media/FlashPoint-Win64-Shipping_6l4ED9Lc19.png',
    ],
    storeLink: 'https://store.steampowered.com/app/4865400/Out_Of_Sync',
    badge: 'Coming Q3 2026',
    platform: 'steam',
    ctaLabel: 'Wishlist on Steam',
  },
  {
    id: 2,
    slug: 'static-voice',
    title: 'Static Voice',
    description:
      'Trapped by toxic gas in a Soviet apartment, Artyom must build an SOS transmitter while evading neighbors hunting in the silence.',
    about:
      'Static Voice is a retro survival horror game set in a Soviet apartment block. Trapped by toxic gas, Artyom must scavenge parts, build an SOS transmitter, and survive while evading neighbors who hunt in the silence.',
    image: '/featured/Banners/header (1).jpg',
    featuredImage: '/featured/Banners/header (1).jpg',
    heroVideo: '/featured/videos/Static Voice Trailer(1).mp4',
    trailerUrl: 'https://youtu.be/olzIe-L0rUg?si=AQBd0Yo_aVLMX8xJ',
    media: [
      '/featured/media/CrownJudgement-Win64-Shipping_1ASC4IdohC.png',
      '/featured/media/CrownJudgement-Win64-Shipping_9bB5e5qcCE.png',
      '/featured/media/CrownJudgement-Win64-Shipping_BxyuRLdcS0.png',
      '/featured/media/CrownJudgement-Win64-Shipping_hoGEmcwLwc.png',
      '/featured/media/CrownJudgement-Win64-Shipping_l7z1LNssWB.png',
      '/featured/media/CrownJudgement-Win64-Shipping_tlMO35cfge.png',
    ],
    storeLink: 'https://store.steampowered.com/app/4207170/Static_Voice/?utm_source=website',
    badge: 'Now Available',
    platform: 'steam',
    ctaLabel: 'Play on Steam',
  },
  {
    id: 3,
    slug: 'life-of-luxury',
    title: 'Life Of Luxury',
    description:
      'Investigating a strange son, two friends barely escape a monster, later discovering the real boy died years ago and the entity was an imposter.',
    about:
      'Life Of Luxury is a short horror experience about two friends investigating a strange boy — only to discover the real child died years ago, and the entity they encountered was an imposter.',
    image: '/Gemini_Generated_Image_lzmwuxlzmwuxlzmw-Photoroom.png',
    featuredImage: '/featured/life-of-luxury.jpg',
    heroVideo: '/featured/videos/Trailer  Life Of Luxury.mp4',
    trailerUrl: 'https://youtu.be/YpRDGF3tu8k?si=xHkYSFVM8VpPCrwT',
    media: [
      '/featured/media/CrownJudgement-Win64-Shipping_Zxg0Gzojhk.png',
      '/featured/media/CrownJudgement-Win64-Shipping_j6HBJieUMT.png',
      '/featured/media/CrownJudgement-Win64-Shipping_i8c6uwl5rw.png',
      '/featured/media/CrownJudgement-Win64-Shipping_iNp2Wx8NH7.png',
    ],
    storeLink: 'https://kadderagames.itch.io/life-of-luxury',
    badge: 'Play on itch.io',
    platform: 'itch',
    ctaLabel: 'Play on itch.io',
  },
  {
    id: 4,
    slug: 'behind-the-counter',
    title: 'Behind The Counter',
    description:
      'Taking an unexpected night shift, you must hide and flee to your car to escape a cult trying to take over your countryside coffee shop.',
    about:
      'Behind The Counter is a horror game about an unexpected night shift at a countryside coffee shop. Hide, flee, and make it to your car before a cult takes over.',
    image: '/Gemini_Generated_Image_fhrwh7fhrwh7fhrw-Photoroom.png',
    featuredImage: '/featured/behind-the-counter.jpg',
    heroVideo: '/featured/videos/Trailer  Behind The Counter.mp4',
    trailerUrl: 'https://youtu.be/kwpG_36htWc?si=IWyVRBFf5I0Ur9XH',
    media: [
      '/featured/media/TheMarionetteLullaby_3n6MRSHHvU.jpg',
      '/featured/media/TheMarionetteLullaby_EIkmKXQ0gD.jpg',
      '/featured/media/TheMarionetteLullaby_IDWFJVqqBI.jpg',
      '/featured/media/TheMarionetteLullaby_whM1TYRppm.jpg',
      '/featured/media/TheMarionetteLullaby_yNXEUk13AG.png',
      '/featured/media/UnrealEditor_m9XM2dv3Kr.jpg',
    ],
    storeLink: 'https://kadderagames.itch.io/behind-the-counter',
    badge: 'Now Available',
    platform: 'itch',
    ctaLabel: 'Play on itch.io',
  },
  {
    id: 5,
    slug: 'flashpoint',
    title: 'Flash Point',
    description:
      'In a rusted workshop of terminals and toolboxes, you must store power, set the proper time, and open the portal before everything collapses.',
    about:
      'Flash Point is a retro atmospheric puzzle adventure. Explore a grimy industrial lab, solve mechanical locks, scavenge tools, and operate old terminals to open a portal — if you can set the proper time and keep the power stored.',
    image: '/featured/media/Gemini_Generated_Image_og6bwiog6bwiog6b.jpeg',
    featuredImage: '/featured/media/Gemini_Generated_Image_og6bwiog6bwiog6b.jpeg',
    media: [
      '/featured/media/FlashPoint-Win64-Shipping_VortiSSioH.png',
      '/featured/media/Nano-Win64-Shipping_9XTZwzWE2z.png',
      '/featured/media/FlashPoint-Win64-Shipping_MncoisYydS.png',
      '/featured/media/FlashPoint-Win64-Shipping_hW3cqSbo86.png',
    ],
    storeLink: 'https://kadderagames.itch.io/the-flash-point',
    badge: 'Now Available',
    platform: 'itch',
    ctaLabel: 'Play on itch.io',
  },
];

export const visibleGames = games.filter((game) => !game.hidden);

export function getGameBySlug(slug: string): Game | undefined {
  const game = games.find((entry) => entry.slug === slug);
  if (!game || game.hidden) {
    return undefined;
  }
  return game;
}
